function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}><title>icon / circle / remove-inventory</title><g fill="none" fillRule="evenodd"><circle fill="#DE002E" cx="16" cy="16" r="14" /><path d="M10.013 17.516H21.9c.82 0 1.486-.767 1.486-1.714s-.666-1.714-1.486-1.714H10.013c-.82 0-1.486.767-1.486 1.714s.666 1.714 1.486 1.714z" fill="#FFF" fillRule="nonzero" /></g></svg>;
});